<template>
    <mm-select :options="users" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			users:[],
		}
	},
	props: {
		value: {
			require: true,
		},
		not_admin: {
			default: () => {
				return false;
			},
			type: Boolean,
		},
	},
	async mounted(){
		if(!this.$cache['users']){
			const body = await this.$post('/user/list',{attributes:['user_id','user_name','group_name']});
			this.$cache['users'] = body.rows.map(v=>{return {value:v['user_name'],label:v['user_name'],group:v['group_name']}});
		}
		this.users = this.$cache['users'];
		if (this.not_admin) {
			this.users = this.users.filter((user) => {
				return user.group !== 'admin';
			})
		}
	}
}
</script>
